import { Component, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ConfirmDialogComponent,
  ConfirmDialogVariant,
  type DialogComponentI,
} from '@core/user-interface-legacy';

export interface ConfirmLoginChangeDialogData {
  login: string;
}

@Component({
  selector: 'rt-confirm-login-change-dialog',
  imports: [ConfirmDialogComponent, TranslatePipe],
  template: `
    <rt-confirm-dialog
      [title]="'tlc.current_user.confirm_username_change_dialog.title' | translate"
      [message]="
        'tlc.current_user.confirm_username_change_dialog.agree_text' | translate: { login: login() }
      "
      [agreeLabel]="'tlc.common.confirm' | translate"
      [cancelLabel]="'tlc.common.cancel' | translate"
      [variant]="ConfirmDialogVariant.Warning"
      [triggerUpdateOnInit]="true"
      [isCancelable]="true"
    />
  `,
})
export class ConfirmLoginChangeDialogComponent
  implements DialogComponentI<ConfirmLoginChangeDialogData, boolean>
{
  public ConfirmDialogVariant: typeof ConfirmDialogVariant = ConfirmDialogVariant;
  public login = signal<string>('');

  public setDialogData(data: ConfirmLoginChangeDialogData): void {
    this.login.set(data.login);
  }
}
